/*
#*===================================================================
#*
#* Licensed Materials - Property of Zuum Transportation Inc.
#*
#* Copyright Zuum 2015-2022. All Rights Reserved.
#*
#*===================================================================
*/

import { UsageReport } from '@core/models';
import { createAction, props } from '@ngrx/store';

export const loadUsageReport = createAction(
  '[ClientDetails:Usage Report] Load Usage Report',
  props<{ clientId?: number; startDate?: string; endDate?: string }>()
);

export const loadUsageReportSuccess = createAction(
  '[ClientDetails:Usage Report] Load Usage Report Success',
  props<{ data: UsageReport[] | null }>()
);

export const loadUsageReportFailure = createAction(
  '[ClientDetails:Usage Report] Load Usage Report Failure',
  props<{ errorMessage: string }>()
);

export const reloadUsageReport = createAction('[ClientDetails:Users] ReLoad Usage Report');

export const noAccessYet = createAction(
  '[ClientDetails:Dasboard] Usage Report - No Access Yet',
  props<{ noAccessYet: boolean }>()
);
